import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const useDeliveryIntervalOptions = ({ deliveryInterval , deliveryIntervalOptionsFallback , availableSubscriptionIntervals  })=>{
    const { getLabel  } = useIntl();
    const deliveryIntervalOptions = (availableSubscriptionIntervals === null || availableSubscriptionIntervals === void 0 ? void 0 : availableSubscriptionIntervals.length) ? availableSubscriptionIntervals.reduce((acc, interval)=>swcHelpers.objectSpread({}, acc, {
            [`${interval} ${getLabel('common.duration.days')}`]: interval
        })
    , {}) : deliveryIntervalOptionsFallback;
    const options = Object.entries(deliveryIntervalOptions !== null && deliveryIntervalOptions !== void 0 ? deliveryIntervalOptions : {});
    const singleDeliveryIntervalOption = options.length === 1 && options[0] ? {
        label: options[0][0],
        value: options[0][1]
    } : undefined;
    const selectedInterval = React.useMemo(()=>{
        if (!!deliveryInterval && options.length) {
            // if we are here, we are guaranteed to have options
            const fallbackOption = options[0];
            const selectedOption = options.find(([_, value])=>value === deliveryInterval
            );
            if (!selectedOption) {
                return {
                    value: fallbackOption[0]
                };
            }
            return {
                value: selectedOption[0]
            };
        }
        return undefined;
    }, [
        deliveryInterval,
        deliveryIntervalOptions
    ]);
    return {
        deliveryIntervalOptions,
        selectedInterval,
        singleDeliveryIntervalOption
    };
};

export { useDeliveryIntervalOptions };
//# sourceMappingURL=use-delivery-interval-options.js.map
